/* (ignored) */


//////////////////
// WEBPACK FOOTER
// url (ignored)
// module id = 700
// module chunks = 0